import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { LevelUpDTO } from '@anidex/shared/types';
import { rewardParts } from '../services/format';


export function LevelUpDialog({ levelUps, onClose }: { levelUps: LevelUpDTO[]; onClose: () => void }) {
  const { t } = useTranslation();
  const ref = useRef<HTMLDialogElement>(null);
  const reached = Math.max(...levelUps.map((levelUp) => levelUp.level));
  const rewards = levelUps.flatMap((levelUp) => rewardParts(levelUp.reward));

  useEffect(() => {
    ref.current?.showModal();
  }, []);

  return (
    <dialog
      ref={ref}
      className="level-up night"
      aria-labelledby="level-up-title"
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <div className="level-up__panel scene">
        <span className="level-up__badge" aria-hidden="true">
          {reached}
        </span>
        <h2 id="level-up-title" className="level-up__title">
          {t('levelUp.title', { level: reached })}
        </h2>
        {rewards.length > 0 && (
          <ul className="level-up__rewards">
            {rewards.map((part, index) => (
              <li key={index}>{part}</li>
            ))}
          </ul>
        )}
        <button type="button" className="button button--primary button--large button--block" onClick={onClose} autoFocus>
          {t('actions.continue')}
        </button>
      </div>
    </dialog>
  );
}
